import objectPath from "object-path";
import merge from "deepmerge";
import config from "@/core/config/layout.config.json";
import ApiService from "@/core/services/api.service";
// action types
export const SET_LOCAL_DB = "setLocalDB";
export const SET_LOCAL_CONFIG = "setLocalConfig";
export const SET_LAYOUT_CONFIG = "setLayoutConfig";
export const RESET_LAYOUT_CONFIG = "resetLayoutConfig";
export const OVERRIDE_LAYOUT_CONFIG = "overrideLayoutConfig";
export const OVERRIDE_PAGE_LAYOUT_CONFIG = "overridePageLayoutConfig";
export const SET_ERROR = "setError";

// mutation types

export default {
  state: {
    config: config,
    initial: config,
    localConfig: {
      loaded: false,
      date_format: "DD/MM/YYYY",
      time_format: "HH:mm",
      weekday: 1,
      line_item: {
        allow_engineer_rate: true,
        allow_adjustment: true,
        allow_item_group: true,
        quotation_item_group: true,
        invoice_item_group: true,
        ticket_item_group: true,
        purchase_order_item_group: true,
        proposal_item_group: true,
        contract_item_group: true,
        allow_qty: true,
        quotation_qty: true,
        invoice_qty: true,
        ticket_qty: true,
        purchase_order_qty: true,
        proposal_qty: true,
        contract_qty: true,
        allow_rate: true,
        quotation_rate: true,
        invoice_rate: true,
        ticket_rate: true,
        purchase_order_rate: true,
        proposal_rate: true,
        contract_rate: true,
        allow_discount: true,
        discount_type: 1,
        tax_type: true,
        quotation_discount: true,
        invoice_discount: true,
        ticket_discount: true,
        purchase_order_discount: true,
        proposal_discount: true,
        contract_discount: true,
        allow_tax: true,
        quotation_tax: true,
        invoice_tax: true,
        ticket_tax: true,
        purchase_order_tax: true,
        proposal_tax: true,
        contract_tax: true,
      },
      entity: [],
      activeCountries: [],
      company_logo: "",
      company_name: "",
    },
    localConfigLoading: false,
    localDB: [],
    localDBInitialized: false,
  },
  getters: {
    /**
     * Get config from layout config
     * @param state
     * @returns {function(path, defaultValue): *}
     */
    layoutConfig: (state) => (path, defaultValue) => {
      return objectPath.get(state.config, path, defaultValue);
    },
    localDB: (state) => (path, defaultValue) => {
      return objectPath.get(state.localDB, path, defaultValue);
    },
    isLocalDBInitialized: (state) => state.localDBInitialized,
    localConfigDB: (state) => state.localConfig,
    localConfigDBLoading: (state) => state.localConfigLoading,
  },
  actions: {
    /**
     * Set and replace the local db
     * @param state
     * @param payload
     */
    [SET_LOCAL_DB](state) {
      return new Promise((resolve) => {
        ApiService.get("get-config")
          .then(({ data }) => {
            state.commit(SET_LOCAL_DB, data);
            resolve(data);
          })
          .catch(({ response }) => {
            state.commit(SET_ERROR, response.data.errors);
          });
      });
    },
    [SET_LOCAL_CONFIG](ctx) {
      if (ctx.state.localConfig?.loaded) {
        return new Promise((resolve) => {
          resolve(ctx.state.localConfig);
        });
      }

      return new Promise((resolve, reject) => {
        ctx.state.localConfigLoading = true;
        ApiService.get("configuration")
          .then(({ data }) => {
            const response = data?.data ?? {};
            ctx.commit(SET_LOCAL_CONFIG, { ...response, loaded: true });
            resolve({ ...response, loaded: true });
          })
          .catch(({ response }) => {
            reject(response.data.errors);
            ctx.commit(SET_ERROR, response.data.errors);
          });
      });
    },
    /**
     * Set and replace the whole config
     * @param state
     * @param payload
     */
    [SET_LAYOUT_CONFIG](state, payload) {
      state.commit(SET_LAYOUT_CONFIG, payload);
    },

    /**
     * Reset the config at the initial state
     * @param state
     */
    [RESET_LAYOUT_CONFIG](state) {
      state.commit(RESET_LAYOUT_CONFIG);
    },

    /**
     * Reset the config using saved config in the cache by the layout builder
     * @param state
     */
    [OVERRIDE_LAYOUT_CONFIG](state) {
      state.commit(OVERRIDE_LAYOUT_CONFIG);
    },

    /**
     * Override config by page level
     * @param state
     * @param payload
     */
    [OVERRIDE_PAGE_LAYOUT_CONFIG](state, payload) {
      state.commit(OVERRIDE_PAGE_LAYOUT_CONFIG, payload);
    },
  },
  mutations: {
    [SET_LOCAL_DB](state, payload) {
      state.localDB = payload;
      state.localDBInitialized = true;
    },
    [SET_LOCAL_CONFIG](state, payload) {
      state.localConfig = payload;
      state.localConfigLoading = false;
    },

    [SET_LAYOUT_CONFIG](state, payload) {
      state.config = payload;
    },
    [RESET_LAYOUT_CONFIG](state) {
      state.config = Object.assign({}, state.initial);
    },
    [OVERRIDE_LAYOUT_CONFIG](state) {
      state.config = state.initial = Object.assign(
        {},
        state.initial,
        JSON.parse(localStorage.getItem("config"))
      );
    },
    [OVERRIDE_PAGE_LAYOUT_CONFIG](state, payload) {
      state.config = merge(state.config, payload);
    },
  },
};
